import { ProductImageRendition } from "@omni/types/api/product/shared/enums/productImageRendition.enum";
import { Media } from "@omni/types/api/shared/bff/media.model";
import { ProductImageRenditions } from "@omni/types/components/product/productImageRenditions.type";

import { ProductImageWrapper } from "@/components/Product/ProductImage/productImage.component";

type ProductImageContainerProps = {
    title: string | undefined;
    medias?: null | Array<Media>;
    rendition?: ProductImageRendition;
    renditions?: ProductImageRenditions;
    isEcoChequesAccepted: boolean;
    hasInstallationService?: boolean;
    className?: string;
    lazyLoad?: boolean;
    parentFit?: boolean;
};

const ProductImageContainer = ({
    title,
    medias,
    renditions,
    isEcoChequesAccepted,
    hasInstallationService = false,
    className,
    lazyLoad = false,
    parentFit = false
}: ProductImageContainerProps) => {
    if (!medias || medias.length === 0) {
        return null;
    }

    return (
        <ProductImageWrapper
            title={title}
            medias={medias}
            renditions={renditions}
            isEcoChequesAccepted={isEcoChequesAccepted}
            hasInstallationService={hasInstallationService}
            className={className}
            lazyLoad={lazyLoad}
            parentFit={parentFit}
        />
    );
};

export { ProductImageContainer };
